import { api } from '@/api/client'

export type AttachedState = {
  route: string
  route_params: Record<string, string | undefined>
  [key: string]: unknown
}

export type FeedbackEntryPoint =
  | 'cmd_k'
  | 'profile_menu'
  | 'error_boundary'
  | 'crash_recovery'
  | 'empty_state'
  | 'contextual_prompt'
  | 'api'

export type CreateFeedbackPayload = {
  message: string
  platform: 'web' | 'ios' | 'android' | 'internal'
  entry_point: FeedbackEntryPoint
  source_url?: string
  attached_state?: AttachedState
  app_version?: string
  user_agent?: string
  request_id?: string
  sentry_event_id?: string
  clinic_id?: number
  /** "This is stopping me treating a patient right now" — severity floor high. */
  patient_impact?: boolean
}

export type CreateFeedbackResponse = {
  reference: string
  id: number
}

export function createFeedback(payload: CreateFeedbackPayload) {
  // api.post prepends '/api/v1' (see src/api/client.ts BASE), so just pass '/feedback' here.
  return api.post<CreateFeedbackResponse>('/feedback', payload)
}

export type MyFeedbackReport = {
  id: number
  reference: string
  message: string | null
  status_label:
    | 'received'
    | 'in_progress'
    | 'waiting_on_you'
    | 'on_our_list'
    | 'fixed'
    | 'closed'
  unread: boolean
  /** Fixed + not yet answered — show "did this sort it?" (audit R6). */
  confirmable: boolean
  conversation_id: number | null
  inserted_at: string
}

export function fetchMyReports() {
  return api.get<{ reports: MyFeedbackReport[] }>('/feedback/mine')
}

/** One-tap resolution verdict. `sorted: false` reopens the case. */
export function confirmResolution(id: number, sorted: boolean) {
  return api.post<{ ok: boolean }>(`/feedback/${id}/confirm`, { sorted })
}

export type KnownIssue = {
  id: number
  title: string
  body: string | null
  inserted_at: string
}

export function fetchKnownIssues() {
  return api.get<{ known_issues: KnownIssue[] }>('/known-issues')
}
